import { isSellable } from "../../../helpers/capacityUsage";

/**
 * Un día se puede elegir sólo si alguno de sus turnos se puede vender.
 *
 * Es el mismo predicado que decide el turno en el desplegable, y por eso no
 * puede haber un día abierto donde ningún turno es seleccionable.
 */
const isSellableDay = (item, capacityUsage) =>
  (item?.entries ?? []).some((entry) => isSellable(entry, capacityUsage));

export const getDates = (array, capacityUsage) => {
  return array
    .filter((item) => isSellableDay(item, capacityUsage))
    .map((item) => item.date);
};

export const addAvailabilityColor = (availabilityDays, capacityUsage) => {
  return availabilityDays?.map((item) => {
    // Rojo = había salida y ya no se puede tomar. El promedio queda sólo para
    // distinguir verde de amarillo entre los días que sí venden.
    if (!isSellableDay(item, capacityUsage)) {
      return { date: item.date, className: "unavailable-day" };
    }

    const percentage = item.occupiedPercentage;

    if (percentage >= 50) {
      return { date: item.date, className: "low-availability-day" };
    }
    return { date: item.date, className: "available-day" };
  });
};
